import { Equipment } from '@models/equipment.model';
import { Line } from '@app/shared/models/line.model';

export class ToolDetails {
    public id: number;
    public toolUid: string;
    public isSpare: boolean;
    public description: string;
    public isToolLifeMonitoredInSap: boolean;
    public isToolLifeMonitoredInPlc: boolean;
    public isToolLifeMonitoredInMes: boolean;
    public hasMaintenaceAtLine: boolean;
    public excludedFromMaintenance: boolean;
    public revisionPercentage: boolean;
    public isEngraved: boolean;
    public partNumbersCount: number;
    public currentProductionCycles: number;
    public currentProductionTime: number;
    public totalProductionLifeTime: number;
    public totalProductionLifeCycles: number;
    public toolRevisionPercent: number;
    public expirationDate: Date;
    public partNumbers = [];
    public insertionCycles = [];
    public equipment: Equipment[] = [];
    public resetCounter: number;
    public mainLine: Line;
    public maintenancePlanId: number;
    public maintanancePlanType: string;
    public maxMaintenance: number;
    public nextRevision: number;
    public currentProductionTimeDisplay: number;
    public nextRevisionDisplay: number;
    public maxMaintenanceDisplay: number;
    public isToolStationedAtERSA: boolean;
    public excludedFromReturn: boolean;
    public directContactWithPCB: boolean;
    public manualHandling: boolean;

    static round(number) {
        return Math.round(number * Math.pow(10, 4)) / Math.pow(10, 4);
    }

    constructor(details: any = {}) {
        this.id = details.id;
        this.toolUid = details.toolUid;
        this.isSpare = !!details.isSpare;
        this.description = details.description;
        this.isToolLifeMonitoredInSap = !!details.isToolLifeMonitoredInSap;
        this.isToolLifeMonitoredInPlc = !!details.isToolLifeMonitoredInPlc;
        this.isToolLifeMonitoredInMes = !!details.isToolLifeMonitoredInMes;
        this.hasMaintenaceAtLine = !!details.hasMaintenaceAtLine;
        this.excludedFromMaintenance = !!details.excludedFromMaintenance;
        this.partNumbersCount = details.partNumbersCount;
        this.revisionPercentage = details.revisionPercentage;
        this.currentProductionCycles = details.currentProductionCycles;
        this.currentProductionTime = details.currentProductionTime;
        this.totalProductionLifeTime = details.totalProductionLifeTime;
        this.totalProductionLifeCycles = details.totalProductionLifeCycles;
        this.toolRevisionPercent = details.toolRevisionPercent;
        this.expirationDate = details.expirationDate;
        this.isEngraved = details.isEngraved;
        this.partNumbers = details.partNumbers || [];
        this.insertionCycles = details.insertionCycles || [];
        this.equipment = details.equipment || [];
        this.resetCounter = details.resetCounter;
        this.mainLine = details.mainLine;
        this.maintenancePlanId = details.maintenancePlanId;
        this.maintanancePlanType = details.maintanancePlanType;
        this.maxMaintenance = details.maxMaintenance;
        this.maxMaintenanceDisplay = details.maxMaintenance;
        this.nextRevisionDisplay = details.nextRevision;
        this.currentProductionTimeDisplay = details.currentProductionTime;
        this.nextRevision = details.nextRevision;
        this.isToolStationedAtERSA = !!details.isToolStationedAtERSA;
        this.excludedFromReturn = !!details.excludedFromReturn;
        this.directContactWithPCB = !!details.directContactWithPCB;
        this.manualHandling = !!details.manualHandling;
    }

    get type() {
        return 'tool-details';
    }

    get lifetimeEstimationActualAndRemaining() {
        return `${ToolDetails.round(this.currentProductionTimeDisplay)} / ${ToolDetails.round(
            this.maxMaintenanceDisplay
        )}`;
    }

    get lifecycleEstimationAndTotal() {
        return `${ToolDetails.round(this.currentProductionCycles)} / ${ToolDetails.round(this.maxMaintenance)}`;
    }

    get lifeCycleCurrentAndUntilRevision() {
        return `${ToolDetails.round(this.currentProductionCycles)} / ${ToolDetails.round(this.nextRevision)}`;
    }

    get lifeTimeCurrentAndUntilRevision() {
        return `${ToolDetails.round(this.currentProductionTimeDisplay)} / ${ToolDetails.round(
            this.nextRevisionDisplay
        )}`;
    }

    get partNumberLabel() {
        return this.partNumbers.map(v => ({ name: `${v.name} - ( ${v.sapGroup} - ${v.sapFamily} )` }));
    }
}
